import { useRef, type CSSProperties } from 'react';
import type { CharacterProfile as CharacterProfileType } from '../types';
import { BiographyPanel } from './BiographyPanel';
import { CharacterSlideshow } from './CharacterSlideshow';
import { StatisticDisplay } from './StatisticDisplay';

interface CharacterProfileProps { character: CharacterProfileType; nextCharacter: CharacterProfileType; imageIndex: number; frameProgress: number; onArm: (character: CharacterProfileType) => void; }

export function CharacterProfile({ character, nextCharacter, imageIndex, frameProgress, onArm }: CharacterProfileProps) {
  const nameClicks = useRef(0);
  const countNameClick = () => {
    if (nameClicks.current >= 13) return;
    nameClicks.current += 1;
    if (nameClicks.current === 13) onArm(character);
  };
  return (
    <main id="character" className={`profile profile--${character.theme.motif}`} style={{ '--accent': character.theme.accent, '--accent-soft': character.theme.accentSoft } as CSSProperties}>
      <div className="profile__art"><CharacterSlideshow character={character} nextCharacter={nextCharacter} imageIndex={imageIndex} frameProgress={frameProgress} /></div>
      <article className="profile__identity">
        <div className="issue-line"><span>{character.issue}</span><b>{character.tournamentTier ?? 'SMACKERS CORE'} // {character.rank}</b></div>
        <h1><button className="profile__name-trigger" type="button" onClick={countNameClick} aria-label={character.name}>{character.name}</button></h1>
        <p className="nickname">{character.nickname}</p>
        <p className="intro-copy">{character.intro}</p>
        <blockquote>“{character.quote}”</blockquote>
        <div className="classification"><span>{character.classification}</span><b>THREAT // {character.threatLevel}</b></div>
      </article>
      <aside className="profile__readout"><StatisticDisplay stats={character.stats} /></aside>
      <div className="profile__bio"><BiographyPanel character={character} /></div>
      <div className="profile__texture" aria-hidden="true" />
    </main>
  );
}
